'use strict';
const angular = require('angular');

export class activationCodeCreateComponent {
  constructor(Config, Auth, ActivationCodeService) {
    'ngInject';

    this.Auth = Auth;
    this.ActivationCodeService = ActivationCodeService;
    this.count = 50;

    this.options = [{
      title: 'Permanent Code',
      type: 'permanent',
      description: 'An activation code which can be used multiple time and thus stays active until it gets deleted'
    },{
      title: 'One-Time Codes',
      type: 'onetime',
      description: 'Create a set of activation codes which will all be usable only once'
    }];

    this.groups = Config.getModuleConfig(Config.Modules.SignUp).getActivationCodeGroups() || [];
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {

    if (this.selectedType == 'permanent')
      this.close({$value: this.selectedType});
    else
      this.create();

  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  create() {
    let code = {
      code: '',
      description: '',
      payload: {},
      group: this.selectedGroup,
      isOneTimeCode: true,
      meta: {
        creationUser: this.Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    let idx = this.groups.findIndex(item => item.group == this.selectedGroup);

    if (idx !== -1) {
      code.payload = this.groups[idx].payload;

      this.ActivationCodeService.createOneTimeCodes({count: this.count}, code, data => {
        console.log(data);
        this.close({$value: this.selectedType});
      }, err => {
        console.log(err);
      })
    }
  }

  getHelpText(type) {
    let idx = this.options.findIndex(o => o.type == type);
    return this.options[idx].description;
  }

}

export default angular.module('conduApp.activationCodeCreateComponent', [])
  .component('activationCodeCreate', {
    template: require('./activation-code-create.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: activationCodeCreateComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/activation-code-create/activation-code-create.component.js